export const DISHtml = ({value, ...props}) => <span dangerouslySetInnerHTML={{__html: value}} {...props} />
